import { KeycloakParsedToken } from '../types/token';

export const isAdmin = (userInfo: KeycloakParsedToken | null): boolean =>
    userInfo?.realm_access?.roles?.includes('redu-admin') ?? false;
